import React from 'react'
import './App.css'
import {BrowserRouter, Route,Routes} from 'react-router-dom'
import {Box} from '@mui/material'
import ExerciseDetail from './pages/ExerciseDetail'
import Home from './pages/Home'
import Navbar from './componenets/Navbar'
import Footer from './componenets/Footer'
const App = () => {
  return (
    <BrowserRouter>
    <Box width="400px" sx = {{width:{xl: '1488px'}}} m = "auto">
      <Navbar/>
      <Routes>
        <Route path= "/" element = {<Home/>}/>
        <Route path= "/exercise/:id" element = {<ExerciseDetail/>}/>
      
      </Routes>
      <Footer/>
      
    </Box>
    </BrowserRouter>
  )
}

export default App